import { api } from '../index';

const QUIZZES_BASE_URL = 'api/quizzes';

async function getQuizzes(): Promise<QuizResponse[]> {
  const result = await api.get(QUIZZES_BASE_URL);
  return result.data;
}

async function getQuizzesStats(): Promise<AllQuizzesStatsResponse> {
  const result = await api.get(`${QUIZZES_BASE_URL}/all_stats`);
  return result.data;
}

async function getQuiz(id): Promise<QuizResponse> {
  const result = await api.get(`${QUIZZES_BASE_URL}/${id}`);
  return result.data;
}

async function getQuizStats(id): Promise<QuizStatsResponse> {
  const result = await api.get(`${QUIZZES_BASE_URL}/${id}/stats`);
  return result.data;
}

async function createQuiz(): Promise<QuizResponse> {
  const result = await api.post(QUIZZES_BASE_URL);
  return result.data;
}

async function updateQuiz(id, data): Promise<QuizResponse> {
  const result = await api.put(`${QUIZZES_BASE_URL}/${id}`, data);
  return result.data;
}

async function deleteQuiz(id) {
  const result = await api.delete(`${QUIZZES_BASE_URL}/${id}`);
  return result.data;
}

async function deleteTeacherQuizSubmission(id) {
  const result = await api.delete(
    `${QUIZZES_BASE_URL}/${id}/delete_teacher_quiz_submission`
  );
  return result.data;
}

async function createQuizQuestion(
  quizId,
  data: QuizQuestionCreateRequest
): Promise<QuizQuestionResponse> {
  const result = await api.post(
    `${QUIZZES_BASE_URL}/${quizId}/questions`,
    data
  );
  return result.data;
}

async function updateQuizQuestion(quizId, data): Promise<QuizQuestionResponse> {
  const result = await api.put(
    `${QUIZZES_BASE_URL}/${quizId}/questions/${data.id}`,
    data
  );
  return result.data;
}

async function deleteQuizQuestion(quizId, questionId): Promise<any> {
  const result = await api.delete(
    `${QUIZZES_BASE_URL}/${quizId}/questions/${questionId}`
  );
  return result.data;
}

async function reorderQuizQuestions(
  quizId: number,
  questionsPosition: QuizQuestionReorder[]
): Promise<QuizQuestionReorder[]> {
  const result = await api.post<QuizQuestionReorder[]>(
    `${QUIZZES_BASE_URL}/${quizId}/update_questions_positions`,
    questionsPosition
  );
  return result.data;
}

async function duplicateQuizQuestion(
  quizId: number,
  questionId: number
): Promise<QuizQuestionResponse[]> {
  const result = await api.post<QuizQuestionResponse[]>(
    `${QUIZZES_BASE_URL}/${quizId}/questions/${questionId}/duplicate`
  );
  return result.data;
}

async function createQuizAnswer(
  quizId,
  questionId,
  data: QuizAnswerCreateRrequest
): Promise<QuizAnswerResponse> {
  const result = await api.post(
    `${QUIZZES_BASE_URL}/${quizId}/questions/${questionId}/answers`,
    data
  );
  return result.data;
}

async function updateQuizAnswer(
  quizId,
  questionId,
  data
): Promise<QuizAnswerResponse> {
  const result = await api.put(
    `${QUIZZES_BASE_URL}/${quizId}/questions/${questionId}/answers/${data.id}`,
    data
  );
  return result.data;
}

async function deleteQuizAnswer(
  quizId: number,
  questionId: number,
  data: number
): Promise<any> {
  const result = await api.delete(
    `${QUIZZES_BASE_URL}/${quizId}/questions/${questionId}/answers/${data}`
  );
  return result.data;
}

async function getQuizSubmissions(
  page = 1,
  quizId: number,
  q: string,
  status: string,
  startDate?: Date,
  endDate?: Date
): Promise<PaginatedResponse<TeacherSolvedQuizListResponse>> {
  let url = `${QUIZZES_BASE_URL}/${quizId}/submissions?page=${page}&q=${encodeURIComponent(
    q
  )}&status=${status}`;
  if (startDate) {
    url = `${url}&date_from=${startDate.toISOString()}`;
  }
  if (endDate) {
    url = `${url}&date_to=${endDate.toISOString()}`;
  }
  const result = await api.get<
    PaginatedResponse<TeacherSolvedQuizListResponse>
  >(url);
  return result.data;
}

async function getQuizSubmission(
  quizId: number,
  submissionId: number
): Promise<TeacherSolvedQuizResponse> {
  const result = await api.get<TeacherSolvedQuizResponse>(
    `${QUIZZES_BASE_URL}/${quizId}/submissions/${submissionId}`
  );
  return result.data;
}

async function deleteQuizSubmission(
  quizId: number,
  submissionId: number
): Promise<any> {
  const result = await api.delete(
    `${QUIZZES_BASE_URL}/${quizId}/submissions/${submissionId}`
  );
  return result.data;
}

async function finishGradingQuizSubmission(
  quizId: number,
  submissionId: number
): Promise<TeacherSolvedQuizResponse> {
  const result = await api.post(
    `${QUIZZES_BASE_URL}/${quizId}/submissions/${submissionId}/finish_grading`
  );
  return result.data;
}

async function autoGradeQuizSubmission(
  quizId: number,
  submissionId: number
): Promise<TeacherSolvedQuizResponse> {
  const result = await api.post(
    `${QUIZZES_BASE_URL}/${quizId}/submissions/${submissionId}/auto_grade`
  );
  return result.data;
}

async function markSolvedAnswerCorrect(
  quizId: number,
  submissionId: number,
  answerId: number
): Promise<TeacherSolvedQuitAnswerGradingResponse> {
  const result = await api.post(
    `${QUIZZES_BASE_URL}/${quizId}/submissions/${submissionId}/answers/${answerId}/correct`
  );
  return result.data;
}

async function markSolvedAnswerIncorrect(
  quizId: number,
  submissionId: number,
  answerId: number
): Promise<TeacherSolvedQuitAnswerGradingResponse> {
  const result = await api.post(
    `${QUIZZES_BASE_URL}/${quizId}/submissions/${submissionId}/answers/${answerId}/incorrect`
  );
  return result.data;
}

export default {
  getQuizzes,
  getQuizzesStats,
  getQuiz,
  getQuizStats,
  createQuiz,
  updateQuiz,
  deleteQuiz,
  deleteTeacherQuizSubmission,
  createQuizQuestion,
  updateQuizQuestion,
  deleteQuizQuestion,
  reorderQuizQuestions,
  duplicateQuizQuestion,
  createQuizAnswer,
  updateQuizAnswer,
  deleteQuizAnswer,
  getQuizSubmissions,
  getQuizSubmission,
  deleteQuizSubmission,
  finishGradingQuizSubmission,
  autoGradeQuizSubmission,
  markSolvedAnswerCorrect,
  markSolvedAnswerIncorrect,
};
